import { Injectable } from '@angular/core';
import { LocalStorageService  } from 'ngx-webstorage';
import { Token } from '../../outros/token.model';
import { Variables } from '../../utils/variables';
import moment from 'moment';
import { jwtDecode } from "jwt-decode";

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(
    private storage: LocalStorageService
  ) { }

  hasToken() {
    return !!this.getToken();
  }

  getTokenData(){
    return jwtDecode(this.getToken().access_token)
  }

  getConvertedData(dataInSeconds: number): Date {
    return new Date(dataInSeconds * 1000)
  }
  
  getToken(): Token {
    // localStorage é a fonte persistida; o cache do ngx-webstorage pode ficar
    // desatualizado se o valor for alterado fora do LocalStorageService.
    const fromDisk = this.readAuthFromDisk();
    if (fromDisk) {
      return fromDisk;
    }
    return this.storage.retrieve(Variables.USER_AUTH);
  }

  private readAuthFromDisk(): Token | null {
    try {
      const raw = localStorage.getItem('ngx-webstorage|user_auth');
      if (!raw) {
        return null;
      }
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? (parsed as Token) : null;
    } catch {
      return null;
    }
  }

  setToken(token: Token){
    this.storage.store(Variables.USER_AUTH, token)
  }

  removeToken() {
    this.storage.clear(Variables.USER_AUTH);
  }

  isTokenExpired() {
    const token = this.getToken();
    if (token) {
      const expDate = this.getConvertedData(this.getTokenData().exp!)
      const isTokenExpired = moment(new Date()).isAfter(expDate)
      return isTokenExpired;
    }
    return true
  }
}
